/* i18n语言包（泰国语） */

export default {
'sys.operator.success': 'ความสำเร็จในการดำเนินงาน',
'业务异常': 'ความผิดปกติทางธุรกิจ',
'网络请求失败，请稍候再试': 'คำขอเครือข่ายล้มเหลวโปรดรอสักครู่เพื่อลองอีกครั้ง',
'请输入公司关键词': 'กรุณาใส่คำหลักของบริษัท',
'公司名不能为空': 'ชื่อบริษัทต้องไม่ว่างเปล่า',
'请输入用户名': 'กรุณาใส่ชื่อผู้ใช้',
'用户名不能为空': 'ชื่อผู้ใช้ไม่สามารถว่างเปล่า',
'请输入密码': 'กรุณาใส่รหัสผ่าน',
'密码不能为空': 'รหัสผ่านต้องไม่ว่างเปล่า',
'长度在 6 到 20 个字符': 'ความยาวตั้งแต่ 6 ถึง 20 ตัวอักษร',
'登录': 'ล็อกอิน',
'退出登录': 'ออกจากระบบ',
'登录成功': 'ล็อกอินสำเร็จ',
'登录失败': 'เข้าสู่ระบบล้มเหลว',
'暂无权限，请联系后台管理员': 'ไม่มีสิทธิ์ชั่วคราวโปรดติดต่อผู้ดูแลระบบหลังบ้าน',
'向右滑动完成拼图': 'ปัดขวาปริศนาเสร็จ',
'刷新': 'รีเฟรช',
'抱歉！': 'ขอโทษนะ!',
'当前页面不存在...': 'ไม่มีหน้าปัจจุบัน...',
'请检查您输入的网址是否正确，或点击下面的按钮返回首页。': 'โปรดตรวจสอบว่า URL ที่คุณป้อนถูกต้องหรือคลิกที่ปุ่มด้านล่างเพื่อกลับไปที่หน้าแรก',
'登录状态已过期，请重新登录!': 'สถานะการเข้าสู่ระบบหมดอายุแล้ว กรุณาเข้าสู่ระบบใหม่!',
'返回首页': 'กลับไปที่บ้าน',
'关闭其他': 'ปิดอื่น ๆ', 
'关闭左侧': 'ปิดซ้าย', 
'关闭右侧': 'ปิดขวา', 
'关闭全部': 'ปิดทั้งหมด',
'搜索': 'ค้นหา',
'清空': 'ล้าง',
'添加': 'เพิ่ม',
'删除': 'ลบ',
'批量删除': 'ลบแบทช์',
'确定': 'ตกลง',
'取消': 'ยกเลิก',
'启用': 'เปิดใช้',
'禁用': 'ปิดการใช้งาน',
'编辑': 'แก้ไข',
'修改': 'แก้ไข',
'审核': 'รีวิว',
'反审核': 'การตรวจสอบย้อนกลับ',
'条码': 'บาร์โค้ด',
'详情': 'รายละเอียด',
'导出Excel': 'ส่งออก Excel',
'边框': 'ชายแดน',
'大': 'ใหญ่',
'中': 'กลาง',
'小': 'ขนาดเล็ก',
'的订单已签收': 'ลงชื่อสั่งซื้อ ',
'，未签收': ' ลงทะเบียน ',
'记住账号密码': 'จำรหัสผ่านของบัญชี',
'MES制造执行系统': 'ระบบดำเนินการผลิต MES',
'委外订单': 'คำสั่งนอกสภา',
'请输入订单号': 'กรุณากรอกหมายเลขการสั่งซื้อ',
'请选择客户': 'กรุณาเลือกลูกค้า',
'请选择订单状态': 'กรุณาเลือกสถานะการสั่งซื้อ',
'单据状态': 'สถานะเอกสาร',
'订单金额合计': 'ยอดการสั่งซื้อรวม',
'预计交货时间': 'เวลาการจัดส่งโดยประมาณ',
'单据日期': 'วันที่เอกสาร',
'已审核': 'ตรวจสอบแล้ว',
'未审核': 'ยังไม่ได้ตรวจสอบ',
'查询': 'สอบถาม',
'导出excel成功！': 'ส่งออก excel สำเร็จ!',
'下达订单': 'วางคำสั่งซื้อ',
'确认要删除该数据吗？': 'ยืนยันจะลบข้อมูลหรือไม่',
'提示': 'เคล็ดลับ',
'待下单': 'การสั่งซื้อ',
'已下单': 'สั่งซื้อแล้ว',
'已确认': 'ได้รับการยืนยันแล้ว',
'已排期': 'ระยะเวลาของแถว',
'生产中': 'ในการผลิต',
'已完工': 'เสร็จสมบูรณ์',
'已出货': 'จัดส่งแล้ว',
'已签收': 'ลงชื่อแล้ว',
'已结算': 'ชำระแล้ว',
'已关闭': 'ปิด',
'开始时间': 'เวลาเริ่มต้น',
'结束时间': 'เวลาสิ้นสุด',
'至': 'ถึง',
'序号': 'หมายเลขซีเรียล',
'客户名称': 'ชื่อลูกค้า',
'创建人': 'สร้างโดย',
'暂无数据': 'ไม่มีข้อมูลในขณะนี้',
'操作': 'การดำเนินงาน',
'订单编号': 'หมายเลขการสั่งซื้อ',
'订单类型': 'ประเภทการสั่งซื้อ',
'订单状态': 'สถานะการสั่งซื้อ',
'试产': 'ทดลองผลิต',
'批量': 'ขนาดล็อต',
'结算方式': 'วิธีการชำระราคา',
'现结': 'ณ ปัจจุบัน',
'月结': 'ปมเดือน',
'季结': 'ปิดฤดูกาล',
'年结': 'สรุปประจำปี',
'添加委外订单': 'เพิ่มคำสั่งนอกสภา',
'编辑委外订单': 'แก้ไขคำสั่งนอกคณะ',
'请输入订单编号': 'กรุณากรอกหมายเลขการสั่งซื้อ',
'请选择订单类型': 'กรุณาเลือกประเภทการสั่งซื้อ',
'请选择结算方式': 'กรุณาเลือกวิธีการชำระราคา',
'请选择预计交货时间': 'โปรดเลือกเวลาจัดส่งโดยประมาณ',
'请输入': 'กรุณากรอก',
'请选择': 'กรุณาเลือก',
'上传BOM文件': 'อัปโหลดไฟล์ BOM',
'过账标记': 'เครื่องหมายการโพสต์',
'过账人': 'ผู้โพสต์',
'过账时间': 'เวลาโพสต์',
'进度': 'ความคืบหน้า',
'生产工单': 'ใบสั่งงานผลิต',
'生产计划': 'แผนการผลิต',
'操作人': 'ดำเนินการโดย',
'订单签收': 'ลงชื่อสั่งซื้อ',
'签收状态': 'สถานะการเซ็นรับ',
'送货单号': 'หมายเลขใบนำส่ง',
'成品名称': 'ชื่อสินค้าสำเร็จรูป',
'规格': 'สเปค',
'送货数': 'จำนวนการจัดส่ง',
'签收成功': 'ลงชื่อสำเร็จ',
'请选择送货单号': 'กรุณาเลือกหมายเลขการจัดส่ง',
'返回': 'กลับ',
'委外订单编号': 'หมายเลขคำสั่งนอกสภา',
'保存': 'บันทึก',
'添加明细': 'เพิ่มรายละเอียด',
'物料编号': 'หมายเลขวัสดุ',
'请选择物料编号': 'กรุณาเลือกหมายเลขวัสดุ',
'物料名称': 'ชื่อวัสดุ',
'物料规格': 'ข้อมูลจำเพาะของวัสดุ',
'单位': 'หน่วย',
'数量': 'ปริมาณ',
'请输入数量': 'กรุณาใส่ปริมาณ',
'单价': 'ราคาต่อหน่วย',
'请输入单价': 'กรุณากรอกราคาต่อหน่วย',
'含税单价': 'ราคาต่อหน่วยรวมภาษี',
'含税合计': 'รวมภาษีแล้ว',
'税率（%）': 'อัตราภาษี (%)',
'请输入税率': 'กรุณากรอกอัตราภาษี',
'税额': 'จำนวนภาษี',
'备注': 'หมายเหตุ',
'销售订单详情': 'รายละเอียดใบสั่งขาย',
'请选择物料': 'กรุณาเลือกวัสดุ',
'请输入物料编号': 'กรุณาใส่หมายเลขวัสดุ',
'请输入物料名称': 'โปรดป้อนชื่อวัสดุ',
'提示：双击选择物料！': 'เคล็ดลับ: คลิกสองครั้งเพื่อเลือกวัสดุ!',
'确认要删除选中数据吗？': 'ยืนยันที่จะลบข้อมูลที่ถูกเลือก?',
'操作成功！': 'การดำเนินการประสบความสำเร็จ!',
'品名/型号': 'ชื่อสินค้า / รุ่น',
'请输入品名/型号': 'กรุณากรอกชื่อรุ่น',
'云端工厂': 'Cloud โรงงาน',
'请输入PCB条码': 'โปรดป้อนบาร์โค้ด PCB',
'请输入客户条码': 'กรุณากรอกบาร์โค้ดของลูกค้า',
'请输入工令单号': 'กรุณาใส่หมายเลขใบสั่ง',
'请选择线别': 'กรุณาเลือก LINE',
'请输入计划序号': 'กรุณาใส่หมายเลขแผน',
'请输入机器编号': 'กรุณากรอกหมายเลขเครื่อง',
'请输入客户订单号': 'กรุณากรอกหมายเลขการสั่งซื้อของลูกค้า',
'请选择结果': 'กรุณาเลือกผลลัพธ์',
'PCB条码': 'บาร์โค้ด PCB',
'板面': 'แผงหน้าปัด',
'客户条码': 'บาร์โค้ดของลูกค้า',
'工令单号': 'หมายเลขใบสั่งงาน',
'成品编号': 'หมายเลขผลิตภัณฑ์สำเร็จรูป',
'成品规格': 'ข้อกำหนดผลิตภัณฑ์สำเร็จรูป',
'线别名称': 'ชื่อบรรทัด',
'线别编号': 'หมายเลขสาย',
'计划序号': 'หมายเลขแผน',
'客户订单': 'คำสั่งซื้อของลูกค้า',
'结果': 'ผลลัพธ์',
'供应商名称': 'ชื่อผู้ให้บริการ',
'供应商编号': 'หมายเลขผู้จัดจำหน่าย',
'机器编号': 'หมายเลขเครื่อง',
'备注信息': 'หมายเหตุ ข้อมูล',
'创建时间': 'สร้างเวลา',
'备述': 'เตรียมคำอธิบาย',
'更新时间': 'อัปเดตเวลา',
'更新人': 'อัพเดทโดย',
'请选择结算状态': 'โปรดเลือกสถานะการชำระราคา',
'未结算': 'ยังไม่ได้ชำระ',
'订单完结': 'คำสั่งซื้อเสร็จสมบูรณ์',
'成品料号': 'หมายเลขวัสดุสำเร็จรูป',
'订单金额': 'จำนวนการสั่งซื้อ',
'结算状态': 'สถานะการตั้งถิ่นฐาน',
'未付金额': 'จำนวนเงินที่ค้างชำระ',
'已付金额': 'จำนวนเงินที่จ่าย',
'生产计划序号': 'หมายเลขกำหนดการผลิต',
'完工收货日期': 'วันที่รับสินค้าเสร็จสมบูรณ์',
'请输入生产日期(D/C)': 'โปรดป้อนวันที่ผลิต (D/C)',
'请输入仓库': 'กรุณาใส่คลังสินค้า',
'请选择来料类型': 'กรุณาเลือกประเภทของวัสดุที่เข้ามา',
'请输入条码编号': 'กรุณากรอกหมายเลขบาร์โค้ด',
'请输入规格描述': 'กรุณากรอกรายละเอียด',
'请输入客户': 'กรุณากรอกข้อมูลลูกค้า',
'请输入储位': 'กรุณาใส่ที่เก็บข้อมูล',
'请输入批次号': 'กรุณาใส่หมายเลขล็อต',
'请选择超期状态': 'กรุณาเลือกสถานะหมดอายุ',
'已超期': 'หมดอายุแล้ว',
'未超期': 'ไม่เกินกำหนด',
'请选择料架': 'กรุณาเลือกชั้นวางวัสดุ',
'请选择条码状态': 'กรุณาเลือกสถานะบาร์โค้ด',
'超期': 'เกินกำหนด',
'请输入特殊物料': 'กรุณาใส่วัสดุพิเศษ',
'请选择仓库': 'กรุณาเลือกคลังสินค้า',
'锁定状态': 'สถานะล็อค',
'条码状态': 'สถานะบาร์โค้ด',
'超期状态': 'สถานะหมดอายุ',
'条码号': 'หมายเลขบาร์โค้ด',
'货架编号': 'หมายเลขชั้นวางของ',
'储位': 'พื้นที่จัดเก็บ',
'生产日期(D/C)': 'วันที่ผลิต (D/C)',
'D/C': 'D/C',
'周期': 'ระยะเวลา',
'客户编号': 'หมายเลขลูกค้า',
'规格描述': 'รายละเอียดสเปค',
'特殊物料': 'วัสดุพิเศษ',
'仓库编号': 'หมายเลขคลังสินค้า',
'仓库名称': 'ชื่อคลังสินค้า',
'备料单日志': 'บันทึกการสำรองข้อมูล',
'来料类型': 'ประเภทของวัสดุที่เข้ามา',
'单位名称': 'ชื่อหน่วย',
'批次': 'ล็อต',
'入库时间': 'เวลาเข้าคลังสินค้า',
'参考储位': 'พื้นที่จัดเก็บอ้างอิง',
'有效日期': 'วันหมดอายุ',
'按条码': 'โดยบาร์โค้ด',
'按物料编号汇总': 'สรุปตามหมายเลขวัสดุ',
'按条码导出': 'ส่งออกโดยบาร์โค้ด',
'按物料编号汇总导出': 'สรุปการส่งออกตามหมายเลขวัสดุ',
'炉后AOI记录': 'บันทึก AOI หลังเตา',
'品质追溯': 'การตรวจสอบคุณภาพ',
'对账管理': 'การจัดการความปรองดอง',
'物料库存': 'สต็อกวัสดุ',
'数量计算': 'การคำนวณปริมาณ',
'数量总和': 'ผลรวมของปริมาณ',
'委外订单详情': 'รายละเอียดการสั่งซื้อนอกคณะกรรมการ',
'是否签收': 'ไม่ว่าจะเป็นการเซ็นรับ',
'未签收':'ไม่มีการลงนาม',
'已出库': 'ออกจากคลังแล้ว',
'成品出库数': 'จำนวนสินค้าคงคลังสินค้าสำเร็จรูป',
'出库单号': 'หมายเลขใบนำส่งสินค้า',
'出库数量': 'จำนวนออกจากคลังสินค้า',
'出库时间': 'เวลาออกจากคลังสินค้า',
'请先勾选需要删除的数据！': 'กรุณาเลือกข้อมูลที่ต้องการลบก่อน!',
'请填写必填项！': 'กรุณากรอกข้อมูลที่จำเป็น!',
'列表为空，请添加数据！': 'รายการว่างเปล่าโปรดเพิ่มข้อมูล!',
'对账管理详情': 'รายละเอียดการบริหารความปรองดอง',
'请输入规格': 'กรุณากรอกรายละเอียด',
'请输入单位': 'กรุณาใส่หน่วย',
'添加物料': 'เพิ่มวัสดุ',
'编辑物料': 'แก้ไขวัสดุ',
'请输入物料规格': 'กรุณาใส่มาตรวัดวัสดุ',
'关闭订单': 'ปิดคำสั่งซื้อ',
'确认要关闭该订单吗？': 'ยืนยันจะปิดคำสั่งหรือไม่',
'订单': 'การสั่งซื้อ',
'物料资料': 'วัสดุวัสดุ',
'物料尺寸': 'ขนาดวัสดุ',
'归属客户编号': 'หมายเลขลูกค้า',
'归属客户': 'ลูกค้าที่เป็นเจ้าของ',
'客户': 'ลูกค้า',
'物料类型': 'ประเภทวัสดุ',
'物料类别': 'ประเภทวัสดุ',
'湿敏元件等级': 'เกรดขององค์ประกอบที่ไวต่อความชื้น',
'工艺路线': 'เส้นทางกระบวนการ',
'默认供应商': 'ผู้ให้บริการปริยาย',
'MRP类别': 'ประเภท MRP',
'包装数': 'จำนวนบรรจุภัณฑ์',
'最大数量': 'จำนวนสูงสุด',
'最小数量': 'จำนวนขั้นต่ำ',
'描述': 'คำอธิบาย',
'物料详情': 'รายละเอียดวัสดุ',
'签收详情': 'รายละเอียดลายเซ็น',
'工单编号': 'หมายเลขใบสั่งงาน',
'送货时间': 'เวลาจัดส่ง',
'签收': 'ลงชื่อรับเงิน',
'全部签收': 'ลงชื่อทั้งหมด',
'下单时间': 'เวลาสั่งซื้อ',
'全部签收时间': 'เวลาลงนามทั้งหมด',
'结算时间': 'เวลาชำระราคา',
'关闭时间': 'เวลาปิด',
'关闭': 'ปิด',
'添加其他费用明细': 'เพิ่มรายละเอียดค่าใช้จ่ายเพิ่มเติม',
'SPI': 'SPI',
'pcb条码号': 'หมายเลขบาร์โค้ด PCB',
'条码序号': 'หมายเลขซีเรียลบาร์โค้ด',
'条码数量': 'จำนวนบาร์โค้ด',
'DC号': 'หมายเลข DC',
'生产数量': 'ปริมาณการผลิต',
'站位': 'ตำแหน่งสถานี',
'位号': 'หมายเลขบิต',
'操作类型': 'ประเภทการดำเนินงาน',
'SMT板用料': 'วัสดุบอร์ด SMT',
'批号': 'หมายเลขล็อต',
'锡膏': 'วางประสาน',
'客户单号': 'หมายเลขหมายเลขลูกค้า',
'有效时间': 'เวลาที่ถูกต้อง',
'失效时间': 'เวลาหมดอายุ',
'钢网': 'ตาข่ายเหล็ก',
'钢网编号': 'จำนวนตาข่ายเหล็ก',
'最大使用次数': 'จำนวนการใช้งานสูงสุด',
'已使用次数': 'จำนวนครั้งที่ใช้',
'张力1': 'ความตึงเครียด 1',
'张力2': 'ความตึงเครียด 2',
'张力3': 'ความตึงเครียด 3',
'张力4': 'ความตึงเครียด 4',
'张力5': 'ความตึงเครียด 5',
'pcb料号': 'หมายเลขวัสดุ PCB',
'pcb名称': 'ชื่อ PCB',
'pcb规格': 'ข้อมูลจำเพาะ PCB',
'客户订单号': 'หมายเลขคำสั่งซื้อของลูกค้า',
'类别': 'หมวดหมู่',
'DIP用料': 'วัสดุ DIP',
'新建用户': 'ผู้ใช้ใหม่',
'新建时间': 'เวลาใหม่',
'先进先出码': 'รหัสออกก่อนออก',
'板序号': 'หมายเลขหมายเลขบอร์ด',
'插件过站': 'ปลั๊กอินข้ามสถานี',
'后焊过站': 'โพสต์สถานีบัดกรี',
'烧录过站': 'สถานีเผาไหม้',
'测试过站': 'สถานีทดสอบ',
'包装过站': 'บรรจุผ่านสถานี',
'成品入库': 'ผลิตภัณฑ์สำเร็จรูปในคลังสินค้า',
'成品出库': 'ผลิตภัณฑ์สำเร็จรูปออกจากคลังสินค้า',
'维修管理': 'การจัดการการบำรุงรักษา',
'检查结果': 'ผลการตรวจสอบ',
'箱号': 'หมายเลขกล่อง',
'装箱数量': 'ปริมาณการบรรจุ',
'建立时间': 'สร้างเวลา',
'累计入库数量': 'จำนวนคลังสินค้าสะสม',
'入库单据': 'เอกสารการเข้าคลัง',
'出库单据': 'เอกสารเผยแพร่',
'箱子容量': 'ความจุกล่อง',
'维修工具': 'เครื่องมือบริการ',
'维修次数': 'จำนวนซ่อม',
'是否返修': 'ไม่ว่าจะเป็นการซ่อมแซม',
'工序名称': 'ชื่อกระบวนการ',
'缺陷数量': 'จำนวนข้อบกพร่อง',
'检验结果': 'ผลการตรวจสอบ',
'维修结果': 'ผลการซ่อมแซม',
'维修日期': 'วันที่ซ่อม',
'外壳序号': 'หมายเลขเชลล์',
'维修用户': 'ซ่อมแซมผู้ใช้',
'请输入成品编号': 'กรุณากรอกหมายเลขผลิตภัณฑ์สำเร็จรูป',
'请输入条码号': 'กรุณากรอกหมายเลขบาร์โค้ด',
'请输入批号': 'กรุณาใส่หมายเลขล็อต',
'请输入箱号': 'กรุณากรอกหมายเลขกล่อง',
'请输入钢网编号': 'กรุณาใส่หมายเลขตาข่ายเหล็ก',
'请输入站位': 'กรุณาใส่ตำแหน่ง',
'请选择操作类型': 'กรุณาเลือกประเภทการทำงาน',
'请输入入库单据': 'กรุณากรอกเอกสารการฝากเงิน',
'请输入出库单据': 'โปรดป้อนเอกสารการออกคลัง',
'请选择工序': 'โปรดเลือกขั้นตอน',
'请输入位号': 'กรุณาใส่หมายเลขบิต',
'合计(含税)': 'ราคารวม (รวมภาษี)',
'成品入库数': 'ผลิตภัณฑ์สำเร็จรูปเข้าคลัง',
'成品签收数': 'จำนวนลายเซ็นของผลิตภัณฑ์สำเร็จรูป',
'入库单号': 'หมายเลขทะเบียนสินค้า',
'入库数量': 'จำนวนคลังสินค้า',
'签收数量': 'จำนวนลายเซ็น',
'签收时间': 'เวลาเซ็นรับ',
'签收单号': 'หมายเลขสลิปที่ลงลายมือชื่อ',
'不输入则系统分配默认单号': 'หากไม่ป้อน ระบบจะกำหนดหมายเลขเดี่ยวปริยาย',
'操作成功': 'ความสำเร็จในการดำเนินงาน',
'详情删除成功！': 'รายละเอียดลบสำเร็จ!',
'其他费用明细删除成功！': 'รายละเอียดค่าใช้จ่ายอื่น ๆ ลบสำเร็จ!',
'详情保存成功！': 'รายละเอียดบันทึกสำเร็จ!',
'其他费用明细保存成功！': 'รายละเอียดค่าใช้จ่ายอื่น ๆ บันทึกสำเร็จ!',
'模块码': 'รหัสโมดูล',
'请输入模块码': 'โปรดป้อนรหัสโมดูล',
'请输入含税单价': 'กรุณากรอกราคาต่อหน่วยรวมภาษี',
'工作台':'โต๊ะทำงาน',
'邮箱':'กล่องจดหมาย',
'微信':'วีแชท',
'验证码':'รหัสยืนยัน',
'绑定':'ผูก',
'解绑':'แก้มัด',
'请输入邮箱':'กรุณากรอกกล่องจดหมาย',
'请输入微信':'กรุณากรอก WeChat',
'请输入验证码':'กรุณากรอกรหัสยืนยัน',
'秒后重试':'ลองอีกครั้งในวินาที',
'发送验证码':'ส่งรหัสยืนยัน',
'用户名':'ชื่อผู้ใช้',
'密码':'รหัสผ่าน',
'手机号码':'หมายเลขโทรศัพท์มือถือ',
'所属供应商':'ผู้ให้บริการในเครือ',
'个人信息':'ข้อมูลส่วนบุคคล',
'账号绑定':'การผูกบัญชี',
'已绑定':'ผูกพันแล้ว',
'未绑定':'ไม่ผูก',
'绑定邮箱，可及时接收订单动态':'กล่องจดหมายผูกไว้สามารถรับคำสั่งซื้อได้ทันเวลา',
'绑定微信，可及时接收订单动态':'ผูก WeChat สามารถรับคำสั่งซื้อได้ทันเวลา',
'请输入正确的手机号':'กรุณากรอกหมายเลขโทรศัพท์มือถือที่ถูกต้อง',
'修改成功':'แก้ไขสำเร็จ',
'修改失败':'การแก้ไขล้มเหลว',
'请查看电子邮箱获取验证码':'โปรดตรวจสอบอีเมลเพื่อรับรหัสยืนยัน',
'请查看微信验证':'โปรดตรวจสอบการยืนยัน WeChat',
'请输入电子邮件地址':'โปรดป้อนที่อยู่อีเมล',
'请输入有效的电子邮件地址':'โปรดป้อนที่อยู่อีเมลที่ถูกต้อง',
'请输入微信账号':'กรุณากรอกหมายเลขบัญชี WeChat',
'请选择送货单':'กรุณาเลือกแบบฟอร์มการจัดส่ง',
'关闭标记':'ปิดเครื่องหมาย',
'待办处理':'การจัดการอุปทูต',
'去下单':'ไปสั่งซื้อ',
'去签收':'ไปเซ็นรับ',
'去处理':'การกำจัด',
'订单号':'หมายเลขการสั่งซื้อ',
'事物类型':'ประเภทของสิ่งต่างๆ',
'代签收':'ลงนามแทน',
'待齐套':'ชุดที่จะครบ',
'以排期':'สำหรับระยะเวลาการจัดแถว',
'生产不良原因统计': 'สถิติเกี่ยวกับสาเหตุของการผลิตที่มีปัญหา',
'IPQC总不良数': 'จำนวนรวมของข้อบกพร่อง IPQC',
'工单完成进度': 'ความคืบหน้าในการดำเนินงานตามใบสั่งงาน',
'订单数量': 'จำนวนคำสั่งซื้อ',
'日产量达成情况': 'สถานะการบรรลุเป้าหมายการผลิตรายวัน',
'目标数': 'จำนวนเป้าหมาย',
'实际数': 'จำนวนจริง',
'产量完成环比分析': 'การวิเคราะห์การเปลี่ยนแปลงรายเดือนของการบรรลุเป้าหมายการผลิต',
'当天': 'ในวันนี้',
'7天': '7 วัน',
'便携引导': 'การนำทางแบบพกพา',
'委外订单下达': 'การวางคำสั่งซื้อจากภายนอก',
'加工订单录入,实现全流程溯源管理': 'การบันทึกคำสั่งซื้อการผลิตเพื่อการจัดการการติดตามกระบวนการทั้งหมด',
'物料齐套': 'วัสดุครบถ้วน',
'订单计划排期,工单物料齐套': 'การวางแผนและกำหนดเวลาคำสั่งซื้อ และวัสดุสำหรับใบสั่งงานครบถ้วน',
'通过条码查看生产过程信息': 'ดูข้อมูลกระบวนการผลิตผ่านรหัสบาร์โค้ด',
'订单对账': 'การปรับสมดุลคำสั่งซื้อ',
'订单对账及结束订单': 'การปรับสมดุลและปิดคำสั่งซื้อ',
'预警信息': 'ข้อมูลเตือนภัยล่วงหน้า',
'订单结算统计': 'สถิติการปิดบัญชีคำสั่งซื้อ',
'物料欠料明细': 'รายละเอียดวัสดุที่ขาด',
'日记账号': 'บัญชีบันทึกประจำวัน',
'导出明细': 'ส่งออกรายละเอียด',
'欠料': 'วัสดุที่ขาด',
'全部': 'ทั้งหมด',
'物料齐套处理': 'การจัดการวัสดุครบชุด',
'齐套方式': 'วิธีการครบชุด',
'请选择齐套方式': 'โปรดเลือกวิธีการครบชุด',
'预计到料时间': 'เวลาคาดว่าจะมีวัสดุมาถึง',
'联系人': 'ผู้ติดต่อ',
'联系方式': 'ข้อมูลติดต่อ',
'请选择联系方式': 'โปรดเลือกข้อมูลติดต่อ',
'当前库存': 'สต็อกปัจจุบัน',
'工单需求数': 'จำนวนความต้องการในใบงาน',
'差异数': 'จำนวนที่แตกต่าง',
'首件': 'ชิ้นแรก',
'工单组名称': 'ชื่อกลุ่มใบงาน',
'工单组编号': 'หมายเลขกลุ่มใบงาน',
'状态': 'สถานะ',
'是否已计算': 'ได้คำนวณแล้วหรือไม่',
'已开始': 'เริ่มแล้ว',
'发料': 'แจกจ่ายวัสดุ',
'已发料': 'วัสดุที่แจกจ่ายแล้ว',
'下线': 'ออกจากสาย',
'备料': 'เตรียมวัสดุ',
'激活': 'เปิดใช้งาน',
'客户齐套': 'ความครบชุดของลูกค้า',
'齐套确认': 'ยืนยันความครบชุด',
'微信扫一扫':'WeChat กวาด',
'未完成': 'ไม่เสร็จ',
'完成': 'เสร็จ',
'未分类': 'ยังไม่ได้จัดประเภท',
'不良原因': 'สาเหตุที่ไม่ดี',
'订单交期超期提醒': 'การเตือนว่ากำหนดส่งสินค้าเกินกำหนด',
'工单总需求数': 'จำนวนความต้องการรวมของคำสั่งงาน',
'理论库存': 'คลังสินค้าทฤษฎี',
'允损数': 'จำนวนที่ยอมรับความเสียหาย',
'余数': 'จำนวนคงเหลือ',
'替代主料': 'วัตถุดิบที่ใช้แทนหลัก',
'齐套': 'ชุดครบ',
'必须选择预计到料时间': 'ต้องเลือกเวลาที่คาดว่าจะมีวัสดุมาถึง',
'必须选择齐套方式': 'ต้องเลือกวิธีการชุดครบ',
'必须填写联系人': 'ต้องกรอกข้อมูลผู้ติดต่อ',
'必须填写联系方式': 'ต้องกรอกข้อมูลการติดต่อ',
'是否是替代料': 'เป็นวัสดุทดแทนหรือไม่',
'已齐套':'ครบชุด',
'齐套状态':'สถานะชุดครบทุกชิ้น',
'齐套单号': 'ชุดเดียวครบชุด',
'加载中...': 'กำลังโหลด...',
'为了更方便您关注订单的实时状态，建议您进入个人中心完善资料，系统将更好的为您服务！': 'เพื่อความสะดวกในการติดตามสถานะการสั่งซื้อแบบเรียลไทม์ขอแนะนำให้คุณเข้าสู่ศูนย์ส่วนบุคคลเพื่อปรับปรุงโปรไฟล์และระบบจะทำงานได้ดียิ่งขึ้น!',
'请设置密码': 'โปรดตั้งรหัสผ่าน',
'请设置确认密码': 'โปรดตั้งรหัสผ่านยืนยัน',
'订单交付超期提醒': 'คำเตือนการส่งสินค้าล่าช้า',
'易损物料最低库存预警': 'คำเตือนสต็อกวัสดุที่เสียหายได้ง่ายต่ำ',
'订单超时未下单提醒': 'คำเตือนเวลาหมดอายุของคำสั่งซื้อ',
'订单未签收提醒': 'คำเตือนการไม่รับสินค้า',
'订单已完成加工,未关闭提醒': 'คำเตือนการดำเนินการเสร็จสิ้น แต่ยังไม่ปิดคำสั่งซื้อ',
'微信公众号': 'บัญชีสาธารณะ WeChat',
'绑定微信公众号，可及时接收订单动态': 'ผูกหมายเลขสาธารณะ WeChat เพื่อรับการเปลี่ยนแปลงการสั่งซื้อในเวลาที่เหมาะสม',
'微信小程序': 'แอพเพล็ต WeChat',
'绑定微信小程序，可随时查看订单动态': 'ผูกแอปเพล็ต WeChat เพื่อดูความเคลื่อนไหวของการสั่งซื้อได้ตลอดเวลา',
'请输入原始密码': 'กรุณาป้อนรหัสผ่านปัจจุบัน',
'请输入新密码': 'กรุณาป้อนรหัสผ่านใหม่',
'请再次输入新密码': 'กรุณาป้อนรหัสผ่านใหม่อีกครั้ง',
'密码修改': 'การแก้ไขรหัสผ่าน',
'信息修改': 'การแก้ไขข้อมูล',
'旧密码': 'รหัสผ่านเก่า',
'新密码': 'รหัสผ่านใหม่',
'确认密码': 'ยืนยันรหัสผ่าน',
'修改密码': 'เปลี่ยนรหัสผ่าน',
'使用账号登录': 'เข้าสู่ระบบโดยใช้หมายเลขบัญชี',
'二维码获取失败': 'การรับรหัส QR ล้มเหลว',
'二维码已过期': 'รหัส QR หมดอายุ',
'重新获取二维码': 'รับรหัส QR อีกครั้ง',
'调用微信登录接口失败': 'การเรียกอินเทอร์เฟซการเข้าสู่ระบบ WeChat ล้มเหลว',
'获取imes系统用户信息失败': 'ล้มเหลวในการรับข้อมูลผู้ใช้ระบบ imes',
'获取imes系统账号信息失败': 'ล้มเหลวในการรับข้อมูลบัญชีระบบ imes',
'获取imes系统租户信息失败': 'การรับข้อมูลผู้เช่าระบบ imes ล้มเหลว',
'您的微信还没有绑定系统账号，请用系统账号登陆后，在个人中心进行微信账号绑定': 'WeChat ของคุณยังไม่ได้ผูกบัญชีระบบ โปรดผูกบัญชี WeChat ที่ศูนย์ส่วนบุคคลหลังจากลงชื่อเข้าใช้ด้วยบัญชีระบบ',
'发送短信配置': 'การกำหนดค่าการส่ง SMS',
'发送短信手机号': 'การส่ง SMS หมายเลขโทรศัพท์มือถือ',
'请输入手机号': 'กรุณากรอกหมายเลขโทรศัพท์มือถือ',
'是否开启订单变更短信通知': 'ไม่ว่าจะเป็นการเปิด SMS แจ้งเตือนการเปลี่ยนแปลงคำสั่ง',
'发送短信服务': 'บริการส่ง SMS',
'工单排期': 'ระยะเวลาการปล่อยเดี่ยวงาน',
'工单生产': 'การผลิตคำสั่งงาน',
'工单完成': 'คำสั่งซื้อเสร็จสมบูรณ์',
'工单签收': 'การลงลายมือชื่อใบสั่งงาน',
'请输入完整的手机号码': 'กรุณากรอกหมายเลขโทรศัพท์มือถือให้ครบถ้วน',
'验证码获取成功': 'ความสำเร็จในการรับ CAPTCHA',
'绑定手机号': 'ผูกหมายเลขโทรศัพท์มือถือ',
'解绑手机号': 'ถอดรหัสหมายเลขโทรศัพท์มือถือ',
'验证当前手机号': 'ตรวจสอบหมายเลขโทรศัพท์มือถือปัจจุบัน',
'修改手机号': 'แก้ไขหมายเลขโทรศัพท์มือถือ',
'开启': 'เปิด',
'工单完工': 'ใบสั่งงานเสร็จสมบูรณ์',
'手机号': 'หมายเลขโทรศัพท์มือถือ',
'获取验证码': 'รับรหัสยืนยัน',
'验证': 'การตรวจสอบ',
'短信拒收时间': 'เวลาปฏิเสธ SMS',
}